import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * Just names that are used in various places in the queries
 */
export enum CommonName {
  Key = 'key',
  Period = 'period',
  Position = 'position',
  Search = 'search',
  Selection = 'selection',
  Value = 'value',
}
// Needs to be before namespace is defined
const COMMON_NAMES: ReadonlySet<CommonName> = new Set(
  Object.values(CommonName) as CommonName[],
)
export namespace CommonName {
  export const ALL: readonly CommonName[] = Array.from(COMMON_NAMES)
  export const isCommonName = TypeChecker.Factory.oneOf(COMMON_NAMES)
  export const assertIsCommonName: TypeAsserter<CommonName> =
    TypeAsserter.Factory.from(isCommonName)
}
